import {Modal} from "react-bootstrap";
import React from "react";

export default function DrillDownModal(props) {
    return (
        <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered dialogClassName="modal-90w">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <props.type
                    isModal
                    modalResulotion={props.resolution ? props.resolution : null}
                    barIndex={props.barIndex || null}
                    selectedEntities={props.selectedEntities || null}
                    variant={props.variant || null}
                    selectedDate={props.selectedDate || null}
                    colors={props.colors || null}
                />
            </Modal.Body>
        </Modal>
    );
}